var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDispenseError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.69 397.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b60000;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.8,397.78c-57.83,0-115.67.12-173.51-.14a81.29,81.29,0,0,1-23.09-3.2c-20.32-6.18-30-23.51-24.82-44.09a80.15,80.15,0,0,1,8.27-20.21q86.67-150.64,173.88-301A81.32,81.32,0,0,1,201,8.29C214.41-3,231.2-2.46,245.14,8.16c8,6.09,13.49,14.18,18.44,22.75q59.16,102.51,118.36,205,27,46.72,53.95,93.43c6.41,11.12,11.11,22.76,9.47,36-1.49,12-8,20.61-18.54,26.19-9.21,4.88-19.2,6.26-29.5,6.25q-73.5-.07-147,0Zm15.94-140.34c.25-1.48.48-2.76.67-4.06,4.52-30.46,9.12-60.92,13.5-91.4,1.34-9.36,3.11-18.85,2.83-28.22-.45-15.11-12.14-27.14-27-29.75a32.77,32.77,0,0,0-35.8,18.68c-3.49,7.54-3.87,15.39-2.54,23.46q7.45,45.35,14.78,90.7c1.1,6.83,1.71,13.74,2.54,20.59Zm-49.15,53.65a33.33,33.33,0,0,0,66.65.08,33.33,33.33,0,1,0-66.65-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.74,257.44H207.68c-.83-6.85-1.44-13.76-2.54-20.59q-7.27-45.36-14.78-90.7c-1.33-8.07-1-15.92,2.54-23.46A32.77,32.77,0,0,1,228.7,104c14.9,2.61,26.59,14.64,27,29.75.28,9.37-1.49,18.86-2.83,28.22-4.38,30.48-9,60.94-13.5,91.4C239.22,254.68,239,256,238.74,257.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.59,311.09a33.33,33.33,0,1,1,66.65.08,33.33,33.33,0,0,1-66.65-.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispenseError);
export default __webpack_public_path__ + "static/media/dispense-error.d77abd898af9f9ace2380b0a8fa4c38d.svg";
export { ForwardRef as ReactComponent };